import { render, staticRenderFns } from "./Naturalessentialoil.vue?vue&type=template&id=14c88925&scoped=true&"
import script from "./Naturalessentialoil.vue?vue&type=script&lang=js&"
export * from "./Naturalessentialoil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c88925",
  null
  
)

export default component.exports